<template>
  <v-container class="bottom">
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11 xl10>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <div>
        <v-snackbar
          class="new-alert"
          v-model="alert"
          :timeout="timeout"
          :color="alertType"
          top="top"
        >
          {{this.alertMessage}}
          <v-icon color="white" flat @click="alert = false">close</v-icon>
        </v-snackbar>
      </div>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 offset-xl0 md9 lg10 xs12 sm11 xl10>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12>
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h3 style="text-align: left">Proyección líneas de trabajo</h3>
              <v-layout>
                <v-flex md12 lg12 xs12 sm12>
                  <v-stepper v-model="e6" vertical non-linear>
                    <v-stepper-step
                      color="#394049"
                      :editable="true"
                      :complete="e6 > 1"
                      step="1"
                    >Lineas de trabajo</v-stepper-step>

                    <v-stepper-content step="1">
                      <v-icon size="175" v-if="empty">notification_important</v-icon>
                      <p class="text-p" v-if="empty">No hay líneas creadas</p>
                      <table v-if="!empty" cellpadding="0" cellspacing="0">
                        <thead class="header">
                          <tr>
                            <th
                              style="text-align: left"
                              :class="header.size"
                              v-for="(header,index) in headers1"
                              :key="index"
                            >{{header.text}}</th>
                          </tr>
                        </thead>
                      </table>
                      <div v-if="!empty" class="tbl-content">
                        <table class="table-bordered" cellpadding="0" cellspacing="0" border="1">
                          <tbody>
                            <tr v-for="(item,index) in lineas" :key="index">
                              <td
                                style="text-align:left"
                                :class="headers1[0].size"
                              >{{item.nombreLinea}}</td>

                              <td
                                style="text-align:left"
                                :class="headers1[1].size"
                              >{{item.desarrolloActual}}</td>
                              <td
                                style="text-align:left"
                                :class="headers1[2].size"
                              >{{item.desarrollo2030}}</td>
                              <td :class="headers1[3].size">
                                <v-icon
                                  :disabled="!$session.getAll().permiso"
                                  small
                                  class="mr-2"
                                  @click="openEditLineas(item,index,'edit1')"
                                >edit</v-icon>
                                <v-icon
                                  :disabled="!$session.getAll().permiso"
                                  small
                                  class="mr-2"
                                  @click="openDeleteLineas(item,index)"
                                >delete</v-icon>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <v-btn
                        v-if="this.$session.getAll().permiso"
                        color="#EB7704"
                        @click="opencreateFocos"
                      >Agregar linea</v-btn>
                      <v-btn color="#394049" @click="e6 = 2">Continuar</v-btn>
                    </v-stepper-content>

                    <v-stepper-step color="#394049" :editable="true" :complete="e6 > 2" step="2">
                      En cada una de las dimensiones señaladas, ¿Qué realizará para lograr nivel de desarrollo esperado al 2030?
                      <small>Acciones, programas o proyectos</small>
                    </v-stepper-step>

                    <v-stepper-content step="2">
                      <v-icon size="175" v-if="empty">notification_important</v-icon>
                      <p class="text-p" v-if="empty">No hay líneas creadas</p>
                      <p class="pull">Selecciona la linea de trabajo:</p>
                      <select class="form-control" id="5" v-model="linea">
                        <option value selected="selected" disabled>Selecciona la linea de trabajo</option>
                        <option
                          v-for="(item,index) in lineas"
                          :key="index"
                          :value="item"
                        >{{item.nombreLinea}}</option>
                      </select>
                      <br />
                      <table v-if="!empty" class="header-fixed" cellpadding="0" cellspacing="0">
                        <thead class="header">
                          <tr>
                            <th
                              style="text-align: left"
                              :class="header.border"
                              v-for="(header,index) in headers3"
                              :key="index"
                            >{{header.text}}</th>
                          </tr>
                        </thead>
                        <div v-if="!empty" class="test table table-bordered">
                          <tbody>
                            <tr>
                              <td
                                rowspan="5"
                                style="text-align: justify"
                                class="col-md-1 col-xs-1 col-lg-1 col-sm-1 th-border td-class"
                              >
                                <v-icon
                                  :disabled="!$session.getAll().permiso"
                                  small
                                  class="mr-2"
                                  @click="openEditLineas(linea,index,'edit3')"
                                >edit</v-icon>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="text-align: justify"
                                class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border td-class"
                              >Docencia de pregrado</td>
                              <td
                                style="text-align: justify!important ; width:10000px!important;"
                                class="col-md-4 col-xs-4 col-lg-4 col-sm-4 th-border td-class"
                              >{{linea.respuestaDocencia}}</td>
                              <td
                                style="text-align: justify!important ; width:10000px!important;"
                                class="col-md-5 col-xs-5 col-lg-5 col-sm-5 th-border td-class"
                              >{{linea.necesidadDocencia}}</td>
                            </tr>
                            <tr>
                              <td
                                style="text-align: justify"
                                class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border td-class"
                              >Docencia de postgrado</td>
                              <td
                                style="text-align: justify!important ; width:10000px!important;"
                                class="col-md-4 col-xs-4 col-lg-4 col-sm-4 th-border td-class"
                              >{{linea.respuestaDocencia2}}</td>
                              <td
                                style="text-align: justify!important ; width:10000px!important;"
                                class="col-md-5 col-xs-5 col-lg-5 col-sm-5 th-border td-class"
                              >{{linea.necesidadDocencia2}}</td>
                            </tr>
                            <tr>
                              <td
                                style="text-align: justify"
                                class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border td-class"
                              >Investigación</td>
                              <td
                                style="text-align: justify"
                                class="col-md-4 col-xs-4 col-lg-4 col-sm-4 th-border td-class"
                              >{{linea.respuestaInvestigacion}}</td>
                              <td
                                style="text-align: justify"
                                class="col-md-5 col-xs-5 col-lg-5 col-sm-5 th-border td-class"
                              >{{linea.necesidadInvestigacion}}</td>
                            </tr>

                            <tr>
                              <td
                                style="text-align: justify"
                                class="col-md-2 col-xs-2 col-lg-2 col-sm-2 th-border td-class"
                              >Vinculación con el medio</td>
                              <td
                                style="text-align: justify"
                                class="col-md-4 col-xs-4 col-lg-4 col-sm-4 th-border td-class"
                              >{{linea.respuestaVinculacion}}</td>
                              <td
                                style="text-align: justify"
                                class="col-md-5 col-xs-5 col-lg-5 col-sm-5 th-border td-class"
                              >{{linea.necesidadVinculacion}}</td>
                            </tr>
                            <tr></tr>
                          </tbody>
                        </div>
                      </table>
                      <v-btn color="#394049" @click="e6 = 1">Atrás</v-btn>
                      <v-btn color="#EB7704" @click="e6 = 3">Continuar</v-btn>

                      <!-- <v-btn color="#EB7704" @click="finish()">Finalizar etapa</v-btn> -->
                    </v-stepper-content>

                    <v-stepper-step
                      color="#394049"
                      :editable="true"
                      :complete="e6 > 3"
                      step="3"
                    >Observación</v-stepper-step>

                    <v-stepper-content step="3">
                      <label for="comment">Observación</label>
                      <textarea class="form-control" rows="5" id="comment" v-model="observacion"></textarea>
                      <v-btn color="#394049" @click="e6 = 2">Atrás</v-btn>
                      <v-btn
                        v-if="this.$session.getAll().permiso"
                        color="#EB7704"
                        @click="editObservacion"
                      >Agregar Observación</v-btn>
                    </v-stepper-content>
                  </v-stepper>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-dialog v-model="edit" width="700px" persistent>
        <template v-slot:activator="{ on }"></template>
        <v-card class="new-card">
          <v-card-title>
            <span class="headline" v-if="!create">Edita tu Linea de trabajo</span>
            <span class="headline" v-if="create">Crea una Linea de trabajo</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Indique el nombre de la linea de Trabajo</label>
                <input v-model="linea.nombreLinea" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="sel1"
                >En base a las relaciones que establece, sus publicaciones y proyectos, indique si usted considera que su línea de trabajo esta en un nivel: Incipiente, en desarrollo o consolidada</label>
                <select class="form-control" id="sel1" v-model="linea.desarrolloActual">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Incipiente">Incipiente</option>
                  <option value="En desarrollo">En desarrollo</option>
                  <option value="Consolidada">Consolidada</option>
                </select>
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="sel1"
                >¿Cuál es el nivel de desarrollo esperado al 2030? (Si su opción en la pregunta anterior es "consolidada", señalar "potenciada")</label>
                <select class="form-control" id="sel1" v-model="linea.desarrollo2030">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Incipiente">Incipiente</option>
                  <option value="En desarrollo">En desarrollo</option>
                  <option value="Consolidada">Consolidada</option>
                  <option value="Potenciada">Potenciada</option>
                </select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editLinea()">Guardar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="create" @click="createLinea()">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="edit1" width="700px" persistent>
        <template v-slot:activator="{ on }"></template>
        <v-card class="new-card">
          <v-card-title>
            <span class="headline" v-if="!create">Edita tu Linea de trabajo</span>
            <span class="headline" v-if="create">Crea una Linea de trabajo</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Linea de Trabajo</label>
                <input
                  disabled
                  v-model="linea.nombreLinea"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <br />

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="sel1"
                >En base a las relaciones que establece, sus publicaciones y proyectos, indique si usted considera que su línea de trabajo esta en un nivel: Incipiente, en desarrollo o consolidada</label>
                <select class="form-control" id="sel1" v-model="linea.desarrolloActual">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Incipiente">Incipiente</option>
                  <option value="En desarrollo">En desarrollo</option>
                  <option value="Consolidada">Consolidada</option>
                </select>
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="sel1"
                >¿Cuál es el nivel de desarrollo esperado al 2030? (Si su opción en la pregunta anterior es "consolidada", señalar "potenciada")</label>
                <select class="form-control" id="sel1" v-model="linea.desarrollo2030">
                  <option selected disabled>-Selecciona una opción-</option>
                  <option value="Incipiente">Incipiente</option>
                  <option value="En desarrollo">En desarrollo</option>
                  <option value="Consolidada">Consolidada</option>
                  <option value="Potenciada">Potenciada</option>
                </select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit1 = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editLinea()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="edit3" width="700px" persistent>
        <template v-slot:activator="{ on }"></template>
        <v-card class="new-card">
          <v-card-title>
            <span class="headline" v-if="!create">Edita tu Linea de trabajo</span>
            <span class="headline" v-if="create">Crea una Linea de trabajo</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Linea de Trabajo</label>
                <input
                  disabled
                  v-model="linea.nombreLinea"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <br />

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label
                  for="sel1"
                >¿Qué realizará para lograr ese estado futuro deseado en cada una de las dimensiones señaladas?</label>
              </v-flex>
            </v-layout>
            <br />

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Docencia de pregrado</label>
                <input v-model="linea.respuestaDocencia" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
            <br />

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Docencia de postgrado</label>
                <input v-model="linea.respuestaDocencia2" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Investigación</label>
                <input
                  v-model="linea.respuestaInvestigacion"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Vinculación con el medio</label>
                <input
                  v-model="linea.respuestaVinculacion"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">¿Qué necesita para lograrlo?</label>
              </v-flex>
            </v-layout>
            <br />

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Docencia de pregrado</label>
                <input v-model="linea.necesidadDocencia" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
            <br />

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Docencia de postgrado</label>
                <input v-model="linea.necesidadDocencia2" type="text" class="form-control" id="usr" />
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Investigación</label>
                <input
                  v-model="linea.necesidadInvestigacion"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <br />
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="sel1">Vinculación con el medio</label>
                <input
                  v-model="linea.necesidadVinculacion"
                  type="text"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
            <br />
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit3 = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" v-if="!create" @click="editLinea()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="eliminar" width="500">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>
            <span
              class="headline"
            >¿Está seguro de querer eliminar la línea de trabajo {{linea.nombreLinea}}?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="eliminar = false">No, cancelar</v-btn>
            <v-btn color="#394049" flat="flat" @click="deleteLinea(linea)">Sí, eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>


<script>
import img1 from "../../assets/BANNER_2.png";
import img3 from "../../assets/nuevaasistenciadca.png";
import nube from "../../assets/nube.png";

export default {
  data() {
    return {
      observacion: "",
      e1: "Selecciona una linea de trabajo",
      projectEdit: false,
      img3: img3,
      img1: img1,
      eliminar: false,
      empty: true,
      e6: 1,
      timeout: 4000,
      alertType: "success",
      alertMessage: "",
      alert: false,
      ccValor: "",
      email: "",
      asistencia: false,
      create: false,
      edit: false,
      edit1: false,
      edit2: false,
      edit3: false,
      index: "",
      dialog: false,
      linea: "",
      headers: [
        {
          text: "¿Cuáles son sus lineas de trabajo?",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "¿Se relaciona con otras disciplinas?",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        },
        {
          text:
            "¿Con cuántas personas desarrolla su línea de trabajo? (indique un número)",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "¿Se relaciona con académicos nacionales de otras IES? (si/no)",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text:
            "¿Se relaciona con académicos internacionales de otras IES? (si/no)",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text:
            "¿Incluyo mis líneas de investigación en la docencia de postgrado?(si/no)",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "Acciones",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],
      headers1: [
        {
          text: "Linea de trabajo",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "Nivel de desarrollo (Incipiente, en desarrollo o consolidada)",
          value: "desacuerdo",
          size: "col-md-4 col-lg-4 col-sm-4 col-xs-4"
        },
        {
          text: "¿Cuál es el nivel de desarrollo esperado al 2030?",
          value: "desacuerdo",
          size: "col-md-5 col-lg-5 col-sm-5 col-xs-5"
        },

        {
          text: "Acciones",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],
      headers3: [
        {
          text: "Responder",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Dimensión",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text:
            "¿Qué realizará para lograr nivel de desarrollo esperado al 2030?",
          size: "col-md-4 col-lg-4 col-sm-4 col-xs-4",
          border: "col-md-4 col-lg-4 col-sm-4 col-xs-4 th-border"
        },
        {
          text: "¿Que necesito para lograrlo?",
          size: "col-md-5 col-lg-5 col-sm-5 col-xs-5",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        }
      ],
      headers2: [
        {
          text: "Linea de trabajo",
          value: "name",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        },
        {
          text:
            "¿Ha desarrollado proyectos investigación en los últimos 5 años? (cuántos)",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text:
            "¿Ha desarrollado otro tipo de proyectos  en los últimos 5 años? (cuántos)",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text:
            "¿Cuántas publicaciones académicas ha realizado en los últimos 5 años?",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text:
            "¿Cuántas publicaciones WOS ha realizado en los últimos 5 años?",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text:
            "¿Cuántas publicaciones SCOPUS ha realizado en los últimos 5 años?",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "Acciones",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      lineas: []
    };
  },
  created() {
    this.email = this.$session.getAll().email;
    this.ccValor = this.$session.getAll().ccData.ccValor;
    this.getLineas();
  },
  methods: {
    finish() {
      this.$router.push({ name: "home" });
      var email = this.$session.getAll().email;

      axios
        .get(
          process.env.ROOT_API + "/etapa/etapaUsuario?email=" + email,
          this.auth
        )
        .then(response => {
          var etapa = response.data;
          etapa.etapa3 = true;
          etapa.etapaFinal = 4;
          axios
            .patch(
              process.env.ROOT_API + "/etapa/updateEtapa",
              etapa,
              this.auth
            )
            .then(response => {
              //console.log(response.data);
            })
            .catch(error => {
              console.error(error);
              this.showAlert("error", error);
            });
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
    },
    getLineas() {
      axios
        .get(
          process.env.ROOT_API +
            "/investigacionConsolidado/allInvestigacionesActuales?ccValor=" +
            this.ccValor,
          this.auth
        )
        .then(response => {
          this.lineas = response.data;
          //console.log(response.data);
          if (response.data.length != 0) {
            this.empty = false;
          } else {
            this.empty = true;
          }
          this.getObservacion();
        })
        .catch(error => {
          console.error(error);
        });
    },

    openEditLineas(linea, index, parteEncuesta) {
      //console.log(parteEncuesta);
      if (parteEncuesta == "edit") {
        this.edit = true;
      }
      if (parteEncuesta == "edit1") {
        this.edit1 = true;
      }
      if (parteEncuesta == "edit2") {
        this.edit2 = true;
      }
      if (parteEncuesta == "edit3") {
        this.edit3 = true;
      }
      this.create = false;

      this.index = index;
      this.linea = linea;
      //console.log(this.linea);
    },

    opencreateFocos() {
      this.create = true;
      this.edit = true;
      this.linea = {};
    },

    editLinea() {
      //console.log(this.linea);
      axios
        .put(
          process.env.ROOT_API +
            "/investigacionConsolidado/updateInvestigacion",
          this.linea,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert(
            "success",
            "Línea " + this.linea.nombreLinea + " editado"
          );
          this.getLineas;
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
      this.edit = false;
      this.edit1 = false;
      this.edit2 = false;
      this.edit3 = false;
    },

    createLinea() {
      this.linea.temporalidad = "Actual";
      axios
        .post(
          process.env.ROOT_API +
            "/investigacionConsolidado/createInvestigacion?ccValor=" +
            this.ccValor,
          this.linea,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert("success", "Línea creada");
          this.getLineas();
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
      this.edit = false;
    },

    openDeleteLineas(linea, index) {
      this.eliminar = true;
      this.index = index;
      this.linea = linea;
    },
    deleteLinea(item) {
      axios
        .delete(
          process.env.ROOT_API +
            "/investigacionConsolidado/delete?idLinea=" +
            item.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert("success", response.data);
          this.getLineas();
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
      this.eliminar = false;
    },
    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    },
    editObservacion() {
      const body = {
        observacion: this.observacion
      };
      axios
        .put(
          process.env.ROOT_API +
            "/centrocosto/addObservacion?ccValor=" +
            this.ccValor,
          body,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert("success", "Observación agregada");
          this.getLineas();
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
    },
    getObservacion() {
      axios
        .get(
          process.env.ROOT_API +
            "/centrocosto/getObservacion?ccValor=" +
            this.ccValor,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.observacion = response.data;
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
    }
  }
};
</script>


<style scoped>
.new-alert {
  z-index: 9000;
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
  
}

.new-alert .theme--light.v-icon{
  color: #ffffff!important;
}
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  height: auto !important;
  overflow-y: auto;
}

.v-card {
  height: auto;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.bottom {
  margin-bottom: 50px !important;
}

.header-fixed {
  width: 100%;
  overflow-y: auto;
  height: 200px !important;
}
.header-fixed > thead,
.header-fixed > thead > tr,
.header-fixed > thead > tr > th {
  display: block;
  text-align: left;
  background: #e47215;
  color: #fff;
}

.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
  background: #f1f1f1;
}

.header-fixed > thead > tr > th {
  float: left;
  font-size: 13px;
}

.header-fixed > tbody > tr > td {
  float: left;
  font-size: 18px;
  background: #f1f1f1;
}

.td-class {
  vertical-align: middle;
  font-size: 12px;
  background: #f1f1f1;
}

.test {
  height: 200px !important;
  overflow-y: auto;
}

.header {
  background: #e47215;
  color: #ffffff;
}
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.tbl-content {
  height: 320px;
  overflow-y: auto;
  margin-top: 0px;
  background: #f1f1f1;
}
th {
  padding: 20px 15px;
  text-align: left;
  font-weight: 500;
  font-size: 13px;
}
td {
  padding: 15px;
  text-align: left;
  vertical-align: middle;
  font-weight: 300;
  font-size: 12px;
  border-bottom: solid 1px rgba(0, 0, 0, 0);
  color: #000000;
}

.text-actividad {
  color: #fff;
  text-align: justify;
}
</style>


// WEBPACK FOOTER //
// src/components/definicionEstrategica/Lineas.vue